import React from "react";
import { Col, Row } from "react-bootstrap";

const DynamicRow = ({ info = [], columns = [] }) => {
  console.log("info::", info);
  console.log("columns::", columns);

  // Add safety checks
  if (!info || !Array.isArray(info) || !columns || !Array.isArray(columns)) {
    return <div>No data available</div>;
  }

  if (info.length === 0) {
    return <div>No records found</div>;
  }

  return (
    <>
      {info.map((item, index) => (
        <div key={index} style={{ 
          marginBottom: '20px', 
          padding: '15px', 
          
        }}>
          {columns.map((column, colIndex) => (
            <Row key={colIndex} style={{ marginBottom: '8px' }}>
              <Col sm={2} style={{ 
                fontWeight: 'bold',   
                color: '#000',              
                padding: '8px',                
              }}>
                {column.display_name || 'N/A'}
              </Col>
              <Col sm={10} style={{ padding: '8px' }}>
                {item[column.element_name] || 'N/A'}
              </Col>
            </Row>
          ))}
        </div>
      ))}
    </>
  );
};

export default DynamicRow;